import { call, delay, put, takeEvery } from 'redux-saga/effects';
import { exposeEventToPartner } from '../../../../Helpers/events';
import ActionTypes from '../../../../Data/ActionTypes';
import getSubmissionStatusQuery from './getSubmissionStatusQuery';

/**
 * Worker
 * Saga polling here https://medium.com/@nitheeshkr115/polling-with-redux-saga-313cb9c5b34
 */
export function* getSubmissionStatusWorker({ payload }) {
  const { submissionId, iFrameId, token } = payload;
  const initialDelaySeconds = 3;
  const intervalSeconds = 2.5;
  let stopPollingAfterSeconds = 60;
  let submissionStatus;
  let isFirstRequestAttempt = true;

  while (
    !submissionStatus?.distribution?.completedAt &&
    stopPollingAfterSeconds > 0
  ) {
    const delayInSeconds = isFirstRequestAttempt
      ? initialDelaySeconds
      : intervalSeconds;
    stopPollingAfterSeconds -= delayInSeconds;
    isFirstRequestAttempt = false;

    try {
      yield delay(delayInSeconds * 1000);

      const variables = { submissionId };
      submissionStatus = yield call(getSubmissionStatusQuery, {
        token,
        variables,
      });

      yield put({
        type: 'SUBMISSION_STATUS/update',
        payload: submissionStatus,
      });

      yield exposeEventToPartner({
        eventType: 'submissionStatusUpdated',
        eventObject: {
          ...submissionStatus,
          iFrameId,
        },
      });
    } catch (error) {
      yield put({
        type: 'SUBMISSION_STATUS/failedGetRequest',
        message: error.message,
      });
      yield delay(intervalSeconds * 1000);
    }
  }
}

/**
 * Redux Watcher
 */
export default function* getSubmissionStatusWatcher() {
  yield takeEvery(ActionTypes.GET_SUBMISSION_STATUS, getSubmissionStatusWorker);
}
